import SignalGoodIcon from '@assets/signal-high.svg?react';
import SignalPoorIcon from '@assets/signal-low.svg?react';
import SignalFairIcon from '@assets/signal-medium.svg?react';
import SignalZeroIcon from '@assets/signal-zero.svg?react';
import SignalExcellentIcon from '@assets/signal.svg?react';
import * as fab from '@fortawesome/free-brands-svg-icons';
import * as far from '@fortawesome/free-regular-svg-icons';
import * as fa from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon, type FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
// import * as fas from '@fortawesome/free-solid-svg-icons';
import { HAIRSP } from '@racemap/utilities/consts/characters';
import { RacemapColors } from '@racemap/utilities/consts/common';
import { VisibilityStates } from '@racemap/utilities/consts/events';
import { USER_ROLE } from '@racemap/utilities/consts/trackers';
import { type FC, forwardRef } from 'react';
import { getStatusColor } from './utils/helpers';

type Props = Omit<FontAwesomeIconProps, 'icon'>;

export const IconCommentDots = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faCommentDots} {...props} ref={ref} key="comment-dots" />
));
export const IconGripVertical = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faGripVertical} {...props} ref={ref} key="grip-vertical" />
));
export const IconBars = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faBars} {...props} ref={ref} key="bars" />
));
export const IconHolder = IconGripVertical;
export const IconPlus = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faPlus} {...props} ref={ref} key="plus" />
));
export const IconMinus = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faMinus} {...props} ref={ref} key="minus" />
));
export const IconTrash = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faTrash} {...props} ref={ref} key="trash" />
));
export const IconErase = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faEraser} {...props} ref={ref} key="eraser" />
));
export const IconVial = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faVial} {...props} ref={ref} key="vial" />
));
export const IconSearch = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faSearch} {...props} ref={ref} key="search" />
));
export const IconWand = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faWandMagicSparkles} {...props} ref={ref} key="magic" />
));
export const IconAI = IconWand;
export const IconOk = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faCheck} {...props} ref={ref} key="check" />
));
export const IconDoubleOk = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faCheckDouble} {...props} ref={ref} key="check-double" />
));
export const IconFail = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faXmark} {...props} ref={ref} key="times" />
));
export const IconClose = IconFail;
export const IconRemove = IconFail;
export const IconSquareCheck = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={far.faCheckSquare} {...props} ref={ref} key="check-square" />
));
export const IconCircleCheck = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faCircleCheck} {...props} ref={ref} key="circle-check" />
));
export const IconCircleQuestion = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faCircleQuestion} {...props} ref={ref} key="question-circle" />
));
export const IconFailCircle = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faXmarkCircle} {...props} ref={ref} key="times-circle" />
));
export const IconExpand = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faExpand} {...props} ref={ref} key="expand" />
));
export const IconCheckCircle = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faCheckCircle} {...props} ref={ref} key="check-circle" />
));
export const IconExclamation = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faExclamation} {...props} ref={ref} key="exclamation" />
));
export const IconExclamationTriangle = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon
    icon={fa.faExclamationTriangle}
    {...props}
    ref={ref}
    key="exclamation-triangle"
  />
));
export const IconExclamationCircle = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faExclamationCircle} {...props} ref={ref} key="exclamation-circle" />
));
export const IconUser = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faUser} {...props} ref={ref} key="user" />
));
export const IconUserEdit = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faUserEdit} {...props} ref={ref} key="user-edit" />
));
export const IconUserClock = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faUserClock} {...props} ref={ref} key="user-clock" />
));
export const IconClockRotateLeft = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faClockRotateLeft} {...props} ref={ref} key="clock-rotate-left" />
));
export const IconUserTie = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faUserTie} {...props} ref={ref} key="user-tie" />
));
export const IconUserGear = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faUserGear} {...props} ref={ref} key="user-gear" />
));
export const IconEmail = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faEnvelope} {...props} ref={ref} name="envelope" key="envelope" />
));
export const IconId = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faIdCard} {...props} ref={ref} name="id-card" key="id-card" />
));
export const IconQRCode = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faQrcode} {...props} ref={ref} name="qrcode" key="qrcode" />
));
export const IconCode = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faCode} {...props} ref={ref} name="code" key="code" />
));
export const IconSquare = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faSquare} {...props} ref={ref} key="square" />
));
export const IconCaretSquareRight = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={far.faCaretSquareRight} {...props} ref={ref} key="caret-square-right" />
));
export const IconCaretSquareLeft = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={far.faCaretSquareLeft} {...props} ref={ref} key="caret-square-left" />
));
export const IconCaretDown = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faCaretDown} {...props} ref={ref} key="caret-down" />
));
export const IconCaretUp = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faCaretUp} {...props} ref={ref} key="caret-up" />
));
export const IconLayerGroup = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faLayerGroup} {...props} ref={ref} key="layer-group" />
));
export const IconObjectGroup = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faObjectGroup} {...props} ref={ref} key="object-group" />
));
export const IconOne = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faDiceOne} {...props} ref={ref} key="one" />
));
export const IconEuro = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faEuroSign} {...props} ref={ref} key="euro-sign" />
));
export const IconDollar = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faDollarSign} {...props} ref={ref} key="euro-sign" />
));
export const IconCreativeCommonsNonCommercial = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fab.faCreativeCommonsNc} {...props} ref={ref} key="creative-commons-nc" />
));
export const IconCreativeCommonsNonCommercialEU = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon
    icon={fab.faCreativeCommonsNcEu}
    {...props}
    ref={ref}
    key="creative-commons-nc-eu"
  />
));
export const IconCreativeCommonsZero = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon
    icon={fab.faCreativeCommonsZero}
    {...props}
    ref={ref}
    key="creative-commons-zero"
  />
));

export const IconTime = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faClock} {...props} ref={ref} key="clock" />
));
export const IconStarSolid = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faStar} {...props} ref={ref} key="star-solid" />
));
export const IconStarRegular = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={far.faStar} {...props} ref={ref} key="star-regular" />
));
export const IconKey = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faKey} {...props} ref={ref} key="key" />
));
export const IconCopy = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faCopy} {...props} ref={ref} key="copy" />
));
export const IconExternal = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faExternalLinkAlt} {...props} ref={ref} key="external-link-alt" />
));
export const IconLink = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faLink} {...props} ref={ref} key="link" />
));
export const IconUnlink = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faUnlink} {...props} ref={ref} key="unlink" />
));

export const IconArrowUp = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faAngleUp} {...props} ref={ref} key="angle-up" />
));
export const IconArrowDown = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faAngleDown} {...props} ref={ref} key="angle-down" />
));
export const IconArrowRight = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faAngleRight} {...props} ref={ref} key="angle-right" />
));
export const IconArrowLeft = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faAngleLeft} {...props} ref={ref} key="angle-left" />
));
export const IconArrowDoubleUp = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faAngleDoubleUp} {...props} ref={ref} key="angle-double-up" />
));
export const IconArrowDoubleDown = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faAngleDoubleDown} {...props} ref={ref} key="angle-double-down" />
));
export const IconArrowDoubleRight = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faAngleDoubleRight} {...props} ref={ref} key="angle-double-right" />
));
export const IconArrowDoubleLeft = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faAngleDoubleLeft} {...props} ref={ref} key="angle-double-left" />
));
export const IconArrowsRotate = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faArrowsRotate} {...props} ref={ref} key="arrows-rotate" />
));
export const IconArrowsLeftRight = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon
    icon={fa.faArrowRightArrowLeft}
    {...props}
    ref={ref}
    key="arrow-right-arrow-left"
  />
));
export const IconSwap = IconArrowsLeftRight;
export const IconArrowsUpDown = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon
    icon={fa.faArrowRightArrowLeft}
    rotation={90}
    {...props}
    ref={ref}
    key="arrow-up-arrow-down"
  />
));
export const IconToggleOn = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faToggleOn} {...props} ref={ref} key="toggle-on" />
));
export const IconToggleOff = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faToggleOff} {...props} ref={ref} key="toggle-off" />
));

export const IconSwitch = ({ on, ...props }: Props & { on: boolean }) => {
  if (on) return <IconToggleOn {...props} style={{ ...props.style, cursor: 'pointer' }} />;
  return <IconToggleOff {...props} style={{ ...props.style, cursor: 'pointer' }} />;
};
export const IconTurnUp = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faTurnUp} {...props} ref={ref} key="arrow-turn-up" />
));
export const IconTurnDown = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faTurnDown} {...props} ref={ref} key="arrow-turn-down" />
));
export const IconTurnRight: FC<Props> = (props) => <IconTurnDown rotation={90} {...props} />;
export const IconRevert = IconTurnRight;
export const IconUndo = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faUndo} {...props} ref={ref} key="undo" />
));

export const IconSort = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faSort} {...props} ref={ref} key="sort" />
));
export const IconSortUp = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faSortUp} {...props} ref={ref} key="sort-up" />
));
export const IconSortDown = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faSortDown} {...props} ref={ref} key="sort-down" />
));
export const IconAmountSortUp = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faSortAmountUp} {...props} ref={ref} key="sort-amount-up" />
));
export const IconAmountSortDown = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faSortAmountDown} {...props} ref={ref} key="sort-amount-down" />
));

export const IconLocation = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faLocationArrow} {...props} ref={ref} key="location-arrow" />
));
export const IconLocationPin = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faLocationPin} {...props} ref={ref} key="location-pin" />
));
export const IconLocationDot = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faLocationDot} {...props} ref={ref} key="location-dot" />
));
export const IconWallet = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faWallet} {...props} ref={ref} key="wallet" />
));
export const IconAndroid = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fab.faAndroid} {...props} ref={ref} key="android" />
));
export const IconIos = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fab.faApple} {...props} ref={ref} key="apple" />
));
export const IconMac = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fab.faApple} {...props} ref={ref} key="apple" />
));
export const IconWindows = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fab.faWindows} {...props} ref={ref} key="windows" />
));
export const IconQuestion = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faQuestion} {...props} ref={ref} key="question" />
));
export const IconQuestionCircle = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faQuestionCircle} {...props} ref={ref} key="question-circle" />
));
export const IconQuestionOutline = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={far.faQuestionCircle} {...props} ref={ref} key="question-circle" />
));
export const IconInfo = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faInfoCircle} {...props} ref={ref} key="info-circle" />
));
export const IconPowerOff = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faPowerOff} {...props} ref={ref} key="power-off" />
));
export const IconDownload = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faCloudDownloadAlt} {...props} ref={ref} key="cloud-download-alt" />
));
export const IconUpload = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faCloudUploadAlt} {...props} ref={ref} key="cloud-upload-alt" />
));
export const IconReload = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faRotateRight} {...props} ref={ref} key="rotate-right" />
));
export const IconSync = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faRotate} {...props} ref={ref} key="rotate" />
));
export const IconSave = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faSave} {...props} ref={ref} key="save" />
));
export const IconExchange = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faExchangeAlt} {...props} ref={ref} key="exchange-alt" />
));
export const IconShoppingCart = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faShoppingCart} {...props} ref={ref} key="shopping-cart" />
));
export const IconCreditCard = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faCreditCard} {...props} ref={ref} key="credit-card" />
));
export const IconOpen = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faFolderOpen} {...props} ref={ref} key="folder-open" />
));
export const IconPlay = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faPlay} {...props} ref={ref} key="play" />
));
export const IconRocket = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faRocket} {...props} ref={ref} key="rocket" />
));
export const IconCompress = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faCompress} {...props} ref={ref} key="compress" />
));
export const IconCrosshairs = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faCrosshairs} {...props} ref={ref} key="crosshairs" />
));
export const IconMousePointer = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faMousePointer} {...props} ref={ref} key="mouse-pointer" />
));

export const IconStripe = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fab.faStripeS} {...props} ref={ref} key="stripe-s" />
));

export const IconSpinnerNoSpin = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faSyncAlt} {...props} ref={ref} key="sync-alt" />
));
/** @deprecated better use ant desing spin component */
export const IconSpinner = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faSyncAlt} {...props} ref={ref} key="sync-alt" spin />
));
export const IconRefresh = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faRedoAlt} {...props} ref={ref} key="redo-alt" />
));
export const IconRepeat = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faRepeat} {...props} ref={ref} key="repeat" />
));

export const IconClock = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faClock} {...props} ref={ref} key="clock" />
));
export const IconGear = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faCog} {...props} ref={ref} key="cog" />
));
export const IconSetting = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faEllipsisH} {...props} ref={ref} key="ellipsis-h" />
));
export const IconVisible = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faEye} {...props} ref={ref} key="eye" />
));
export const IconInvisible = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faEyeSlash} {...props} ref={ref} key="eye-slash" />
));
export const IconColor = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faPaintRoller} {...props} ref={ref} key="paint-roller" />
));
export const IconStart = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faFlagCheckered} {...props} ref={ref} key="flag-checkered" />
));
export const IconFinish = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faFlagCheckered} {...props} ref={ref} key="flag-checkered" />
));
export const IconMapMarked = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faMapMarkedAlt} {...props} ref={ref} key="map-marked-alt" />
));
export const IconMapPin = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faMapPin} {...props} ref={ref} key="map-pin" />
));
export const IconArchive = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faArchive} {...props} ref={ref} key="archive" />
));
export const IconDearchive = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faBoxOpen} {...props} ref={ref} key="dearchive" />
));
export const IconBoxOpen = IconDearchive;
export const IconRestore = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faBoxesPacking} {...props} ref={ref} key="boxes-packing" />
));
export const IconExport = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faFileExport} {...props} ref={ref} key="file-export" />
));
export const IconFile = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faFile} {...props} ref={ref} key="file" />
));
export const IconBell = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faBell} {...props} ref={ref} key="bell" />
));
export const IconBellSlash = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faBellSlash} {...props} ref={ref} key="bell-slash" />
));
export const ProtectedZoneIcon = IconExpand;
// TODO: use the ios specific share icon (in fontawesome 6)
export const IconShareIOS = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faShareAlt} {...props} ref={ref} key="share-alt" />
));
export const IconShareAndroid = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faShareAlt} {...props} ref={ref} key="share-alt" />
));
export const IconMobileAlt = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faMobileAlt} {...props} ref={ref} key="mobile-alt" />
));
export const IconCalculator = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faCalculator} {...props} ref={ref} key="calculator" />
));
export const IconMoney = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faMoneyBill} {...props} ref={ref} key="money-bill" />
));
export const IconEdit = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faEdit} {...props} ref={ref} key="edit" />
));
export const IconEditPen = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faPen} {...props} ref={ref} key="pen" />
));
export const IconApple = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fab.faApple} {...props} ref={ref} key="apple" />
));
export const IconPlayStore = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fab.faGooglePlay} {...props} ref={ref} key="google-play" />
));
export const IconFilter = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faFilter} {...props} ref={ref} key="filter" />
));
export const IconBatteryEmpty = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faBatteryEmpty} {...props} ref={ref} key="battery-empty" />
));
export const IconBatteryQuarter = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faBatteryQuarter} {...props} ref={ref} key="battery-quarter" />
));
export const IconBatteryHalf = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faBatteryHalf} {...props} ref={ref} key="battery-half" />
));
export const IconBatteryThreeQuarter = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon
    icon={fa.faBatteryThreeQuarters}
    {...props}
    ref={ref}
    key="battery-three-quarters"
  />
));
export const IconBatteryFull = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faBatteryFull} {...props} ref={ref} key="battery-full" />
));
export const IconLive = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon
    icon={fa.faCircle}
    color={RacemapColors.AltRed}
    {...props}
    ref={ref}
    key="live"
  />
));
export const IconPast = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faBackwardFast} {...props} ref={ref} key="past" />
));
export const IconBackward = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faBackward} {...props} ref={ref} key="backward" />
));
export const IconFuture = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faForwardFast} {...props} ref={ref} key="future" />
));
export const IconRacemap = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faAnglesRight} {...props} ref={ref} key="racemap" />
));
export const IconPlane = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faPlane} {...props} ref={ref} key="plane" />
));
export const IconCar = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faCar} {...props} ref={ref} key="car" />
));
export const IconPerson = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faPerson} {...props} ref={ref} key="person" />
));

export const IconBattery: FC<Props & { state: number | null }> = ({ state, ...props }) => {
  if (state == null)
    return (
      <IconExclamation
        {...props}
        title={'No Data'}
        style={{ color: RacemapColors.DarkRed, ...props.style }}
      />
    );

  const title = `${Math.floor(state * 100)}${HAIRSP}%`;
  if (state > 0.9)
    return (
      <IconBatteryFull
        {...props}
        title={title}
        style={{ color: RacemapColors.DarkGreen, ...props.style }}
      />
    );
  if (state > 0.75)
    return (
      <IconBatteryThreeQuarter
        {...props}
        title={title}
        style={{ color: RacemapColors.DarkGreen, ...props.style }}
      />
    );
  if (state > 0.5)
    return (
      <IconBatteryHalf {...props} title={title} style={{ color: '#ffc107', ...props.style }} />
    );
  if (state > 0.25)
    return (
      <IconBatteryQuarter {...props} title={title} style={{ color: '#ffc107', ...props.style }} />
    );
  return (
    <IconBatteryEmpty
      {...props}
      title={title}
      style={{ color: RacemapColors.DarkRed, ...props.style }}
    />
  );
};
export const IconPlug = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faPlug} {...props} ref={ref} key="plug" />
));
export const IconUnplugged = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faPlugCircleXmark} {...props} ref={ref} key="power" />
));
export const IconConnected = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faSatelliteDish} {...props} ref={ref} key="satellite-dish" />
));
export const IconSignal = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faSignal} {...props} ref={ref} key="signal" />
));
export const IconNetwork = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faGlobe} {...props} ref={ref} key="globe" />
));
export const IconSatellite = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faSatellite} {...props} ref={ref} key="satellite" />
));
export const IconServer = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faServer} {...props} ref={ref} key="server" />
));
export const IconRunner = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faRunning} {...props} ref={ref} key="running" />
));
export const IconList = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faListAlt} {...props} ref={ref} key="list-alt" />
));
export const IconRuler = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faRuler} {...props} ref={ref} key="ruler" />
));
export const IconClear = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faTimes} {...props} ref={ref} key="times" />
));

export const IconLock = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faLock} {...props} ref={ref} key="lock" />
));
export const IconLockOpen = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faLockOpen} {...props} ref={ref} key="lock-open" />
));
export const IconDraftingRuler = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faDraftingCompass} {...props} ref={ref} key="drafting-compass" />
));
export const IconGlobeEurope = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faGlobeEurope} {...props} ref={ref} key="globe-europe" />
));
export const IconGlobe = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faGlobe} {...props} ref={ref} key="globe" />
));
export const IconGaugeHigh = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faGaugeHigh} {...props} ref={ref} key="gauge-high" />
));
export const IconSpeed = IconGaugeHigh;

export const IconFax = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faFax} {...props} ref={ref} key="fax" />
));
export const IconTableList = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faTableList} {...props} ref={ref} name="table-list" />
));
export const IconTimeline = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faTimeline} {...props} ref={ref} name="timeline" />
));
export const IconMap = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faMap} {...props} ref={ref} name="map" />
));
export const IconHashtag = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faHashtag} {...props} ref={ref} name="hashtag" />
));
export const IconPaintRoller = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faPaintRoller} {...props} ref={ref} name="paint-roller" />
));
export const IconRankingStar = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faRankingStar} {...props} ref={ref} name="ranking-star" />
));
export const IconWrench = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faWrench} {...props} ref={ref} name="wrench" />
));
export const IconChartLine = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faChartLine} {...props} ref={ref} name="chart-line" />
));
export const IconArrowTrendUp = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faArrowTrendUp} {...props} ref={ref} name="arrow-trend-up" />
));
export const IconChartDisconnectedDots = IconArrowTrendUp;
export const IconArrowUpRightDots = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faArrowUpRightDots} {...props} ref={ref} name="arrow-up-right-dots" />
));
export const IconChartConnectedDots = IconArrowUpRightDots;
export const IconToolbox = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faToolbox} {...props} ref={ref} name="toolbox" />
));
export const IconTerminal = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faTerminal} {...props} ref={ref} name="terminal" />
));
export const IconSent = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faPaperPlane} {...props} ref={ref} name="paper-plane" />
));
export const IconTimeout = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faStopwatch} {...props} ref={ref} name="stopwatch" />
));
export const IconDuration = IconTimeout;
export const IconWaiting = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faHourglass} {...props} ref={ref} name="hourglass" />
));
export const IconMoon = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faMoon} {...props} ref={ref} name="moon" />
));
export const IconSun = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faSun} {...props} ref={ref} name="sun" />
));
export const IconSIM = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faSimCard} {...props} ref={ref} name="sim-card" />
));
export const IconTowerCell = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faTowerCell} {...props} ref={ref} name="tower-cell" />
));
export const IconTag = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faTag} {...props} ref={ref} name="tag" />
));
export const IconCalendar = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faCalendar} {...props} ref={ref} name="calendar" />
));
export const IconCalendarXMark = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faCalendarXmark} {...props} ref={ref} name="calendar-day" />
));
export const IconCalenderCheck = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faCalendarCheck} {...props} ref={ref} name="calendar-check" />
));
export const IconBook = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faBook} {...props} ref={ref} name="book" />
));
export const IconDocs = IconBook;
export const IconInStock = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faWarehouse} {...props} ref={ref} name="warehouse" />
));
export const IconOutOfStock = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon
    icon={fa.faArrowRightFromBracket}
    {...props}
    ref={ref}
    name="arrow-right-from-bracket"
  />
));
export const IconMobileRetro = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faMobileRetro} {...props} ref={ref} name="mobile-retro" />
));
export const IconShipping = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faTruckFast} {...props} ref={ref} name="truck-fast" />
));
export const IconBullhorn = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faBullhorn} {...props} ref={ref} name="bullhorn" />
));
export const IconLoads = IconBullhorn;
export const IconMobile = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faMobile} {...props} ref={ref} name="devices-hardware" />
));
export const IconDesktop = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faComputer} {...props} ref={ref} name="desktop" />
));
export const IconDevices = IconMobile;
export const IconTracker = IconMobile;
export const IconShare = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faShare} {...props} ref={ref} name="share" />
));
export const IconWhatsApp = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fab.faWhatsapp} {...props} ref={ref} name="whatsapp" />
));
export const IconBan = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faBan} {...props} ref={ref} name="ban" />
));
export const IconRoute = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faRoute} {...props} ref={ref} name="route" />
));
export const IconBurst = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faBurst} {...props} ref={ref} name="burst" />
));
export const IconHeart = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faHeart} {...props} ref={ref} name="heart" />
));
export const IconWifi = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faWifi} {...props} ref={ref} name="wifi" />
));
export const IconTransponder = IconWifi;
export const IconAlert = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon
    icon={fa.faTriangleExclamation}
    {...props}
    ref={ref}
    name="triangleExclamation"
  />
));
export const IconVolumeXMark = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faVolumeXmark} {...props} ref={ref} name="volume-xmark" />
));
export const IconVolumeHigh = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faVolumeHigh} {...props} ref={ref} name="volume-high" />
));
export const IconPin = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faThumbTack} {...props} ref={ref} key="pin" />
));
export const IconUnpin = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faThumbTackSlash} {...props} ref={ref} key="unpin" />
));
export const IconEllipsis = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faEllipsis} {...props} ref={ref} key="ellipsis" />
));
// TODO: use better icon for this
export const IconOffline = IconFail;
export const IconOnline = IconServer;

export const IconUserReseller = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faUserTie} {...props} ref={ref} name="user-tie" />
));
export const IconUserChecked = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faUserCheck} {...props} ref={ref} name="user-check" />
));
export const IconUserTest = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faUserAstronaut} {...props} ref={ref} name="user-astronaut" />
));
export const IconCircle = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faCircle} {...props} ref={ref} name="circle" />
));
export const IconCircleBan = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faBan} {...props} ref={ref} name="circle-ban" />
));
export const IconGhost = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faGhost} {...props} ref={ref} name="ghost" />
));
export const IconManual = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faHand} {...props} ref={ref} name="hand-pointer" />
));
export const IconTrackBox = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faFax} {...props} ref={ref} name="box" />
));
export const IconUnknown = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faQuestion} {...props} ref={ref} name="question" />
));
export const IconShield = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faShield} {...props} ref={ref} name="shield" />
));
export const IconBullseye = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <FontAwesomeIcon icon={fa.faBullseye} {...props} ref={ref} name="bullseye" />
));

/// SVG Icons Imports
type SVGProps = React.SVGProps<SVGSVGElement> & { title?: string };

export const IconSignalNoSignal = forwardRef<HTMLImageElement, SVGProps>((props, ref) => (
  <SignalZeroIcon {...props} ref={ref} alt="No Signal" />
));
export const IconSignalPoor = forwardRef<HTMLImageElement, SVGProps>((props, ref) => (
  <SignalPoorIcon {...props} ref={ref} alt="Poor Signal" />
));
export const IconSignalFair = forwardRef<HTMLImageElement, SVGProps>((props, ref) => (
  <SignalFairIcon {...props} ref={ref} alt="Fair Signal" />
));
export const IconSignalGood = forwardRef<HTMLImageElement, SVGProps>((props, ref) => (
  <SignalGoodIcon {...props} ref={ref} alt="Good Signal" />
));
export const IconSignalExcellent = forwardRef<HTMLSpanElement, SVGProps>((props, ref) => (
  <SignalExcellentIcon {...props} ref={ref} alt="Excellent Signal" />
));

// Visibility States Icons

export const IconVisibilityArchived = IconArchive;
export const IconVisibilityDraft = IconDraftingRuler;
export const IconVisibilityListed = IconVisible;
export const IconVisibilityUnlisted = IconInvisible;
export const IconVisibilityPublic = IconGlobeEurope;
export const IconVisibility: FC<Props & { visibility: VisibilityStates }> = ({
  visibility,
  ...props
}) => {
  switch (visibility) {
    case VisibilityStates.UNLISTED:
      return <IconVisibilityUnlisted {...props} />;
    case VisibilityStates.LISTED:
      return <IconVisibilityListed {...props} />;
    case VisibilityStates.PUBLIC:
      return <IconVisibilityPublic {...props} />;
    case VisibilityStates.ARCHIVED:
      return <IconVisibilityArchived {...props} />;
    default:
      return <IconVisibilityDraft {...props} />;
  }
};

// Authorization States Icons

export const IconAuthorizationPaid = IconDollar;
export const IconAuthorizationFree = IconCreativeCommonsNonCommercial;
export const IconAuthorizationPaidFreeLoadings = IconCreativeCommonsZero;

// Modules Alias

export const IconPrediction = IconTimeline;
export const IconLeaderboard = IconRankingStar;
export const IconAdvanced = IconWrench;
export const IconAdmin = IconToolbox;
export const IconDatafeed = IconTerminal;
export const IconSponsor = IconStarSolid;
export const IconAdvertising = IconStarSolid;
export const IconRepeatedEvent = IconRepeat;

// Group Alias

export const IconContestGroup = IconLayerGroup;
export const IconStageGroup = (props: Omit<FontAwesomeIconProps, 'icon'> = {}) => (
  <IconLayerGroup rotation={270} {...props} />
);
export const IconSafemap = IconShield;
export const IconRegular = IconMap;

export type StatusIconVariants =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'danger'
  | 'warning'
  | 'info'
  | 'dark'
  | 'light';

// Getter
export const getStatusIcon = (status?: StatusIconVariants, withColor = true) => {
  const style: FontAwesomeIconProps['style'] = {
    color: withColor ? getStatusColor(status) : undefined,
  };

  switch (status) {
    case 'primary':
      return <IconStarSolid style={style} />;
    case 'secondary':
      return <IconQuestionCircle style={style} />;
    case 'success':
      return <IconOk style={style} />;
    case 'danger':
      return <IconFail style={style} />;
    case 'warning':
      return <IconExclamationTriangle style={style} />;
    case 'info':
      return <IconInfo style={style} />;
    case 'dark':
      return <IconMoon style={style} />;
    case 'light':
      return <IconSun style={style} />;
    default:
      return <></>;
  }
};

// User Aliases
export const IconUserAdmin = IconUserGear;
export const IconUserOwner = IconUserTie;
export const IconUserEditor = IconUserEdit;
export const IconUserBorrower = IconUserClock;

export const getUserRoleIcon = (userRole: USER_ROLE | null, isAdmin?: boolean): React.ReactNode => {
  if (isAdmin) return <IconUserAdmin title="admin" />;

  switch (userRole) {
    case USER_ROLE.OWNER:
      return <IconUserOwner title={userRole} />;
    case USER_ROLE.EDITOR:
      return <IconUserEditor title={userRole} />;
    case USER_ROLE.BORROWER:
      return <IconUserBorrower title={userRole} />;
    default:
      return <></>;
  }
};
